import { DataSource } from './generated/graphql';

export const appNameToDisplayName: Record<DataSource, string> = {
  mijnoverheid: 'www.mijnoverheid.nl',
  mijnuwv: 'www.uwv.nl',
  belastingdienst: 'www.belastingdienst.nl',
};

export const appNameToUrl: Record<DataSource, string> = {
  mijnoverheid: 'https://mijn.overheid.nl/',
  mijnuwv: 'https://www.uwv.nl/particulieren/mijnuwv/index.aspx',
  belastingdienst: 'https://mijn.belastingdienst.nl/mbd-pmb/pmb.html',
};

const graphqlFieldToDataSource: Record<string, DataSource> = {
  mijnUwvData: DataSource.Mijnuwv,
  mijnOverheidData: DataSource.Mijnoverheid,
  mijnBelastingdienstData: DataSource.Belastingdienst,
};

export const graphqlTypeToDataSource: Record<string, DataSource> = {
  MijnUwvData: DataSource.Mijnuwv,
  MijnOverheidData: DataSource.Mijnoverheid,
  MijnBelastingdienstData: DataSource.Belastingdienst,
};

export const stringToDataSource: Record<string, DataSource> = {
  mijnuwv: DataSource.Mijnuwv,
  mijnoverheid: DataSource.Mijnoverheid,
  belastingdienst: DataSource.Belastingdienst,
};

export function graphqlFieldToDisplayName(fieldName: string) {
  return appNameToDisplayName[graphqlFieldToDataSource[fieldName]];
}
